<template>
  <div>
    <div class="p-3 text-center text-muted" v-if="!loading.thread && (!thread || thread.length === 0)">
      No messages yet.
    </div>
    <div
      class="thread-container"
      v-infinite-scroll="loadMoreThread"
      :infinite-scroll-disabled="loading.thread"
      :infinite-scroll-immediate-check="true"
      infinite-scroll-distance="100">
      <MessageTemplate
        v-for="(msgItem, msgIndex) in thread"
        :key="`msgItem-${msgIndex}`"
        :sender="msgItem.sender"
        :index="msgIndex">
        <span v-html="msgItem.message"></span>
      </MessageTemplate>
      <div class="p-3 text-center text-muted" v-if="loading.thread">
        Loading messages...
      </div>
    </div>
    <SendMessageTemplate />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

import MessageTemplate from "@/components/conversational-commerce/MessageTemplate";
import SendMessageTemplate from "@/components/conversational-commerce/SendMessageTemplate";
const infiniteScroll = require('vue-infinite-scroll');

export default {
  components: { MessageTemplate, SendMessageTemplate },
  directives: { infiniteScroll },
  data() {
    return {
      orderStatusInterval: null
    }
  },
  computed: {
    ...mapGetters({
      selectedOrder: "conversationalCommerce/selectedOrder",
      loading: "conversationalCommerce/loading",
      thread: "conversationalCommerce/thread",
      thread_pagination: "conversationalCommerce/thread_pagination",
      orderStatus: "conversationalCommerce/orderStatus",
      links: "conversationalCommerce/links",
      orderStatusErrors: "conversationalCommerce/orderStatusErrors"
    })
  },
  mounted() {
    this.$root.$on("startCheckingOrderStatus", () => this.checkOrderStatus());
  },
  beforeDestroy() {
    this.$root.$off("startCheckingOrderStatus");
  },
  methods: {
    loadMoreThread() {
      const payload = {};
      if (
        this.thread_pagination.page < this.thread_pagination.max_page
        && !this.loading.thread
      ) {
        payload['page'] = this.thread_pagination.page += 1;
        this.$store.dispatch("conversationalCommerce/getBrandThread", payload);
      }
    },
    async checkOrderStatus() {
      clearInterval(this.orderStatusInterval);
      if (!this.orderStatus && this.selectedOrder) {
        this.orderStatusInterval = setInterval(async () => {
          await this.$store.dispatch("conversationalCommerce/getCustomerOrderStatus");
        }, 20*1000);
      }
    },
    sendTrackingLink() {
      const { tracking } = this.links;
      const sendMessagePayload = `
        Tracking Link: <a href='${tracking.url}' target='_blank'>${tracking.url}</a><br/>
        Tracking Link Validate: ${this.$moment(tracking.validity).format("MMM DD, YYYY h:mm:ss A")}
      `;
      this.$store.dispatch("conversationalCommerce/sendMessage", sendMessagePayload);
    }
  },
  watch: {
    async orderStatus(isNotEmpty) {
      if (isNotEmpty) {
        clearInterval(this.orderStatusInterval);
        await this.sendTrackingLink();
        await this.$store.dispatch("conversationalCommerce/getCustomerCart");
      }
    },
    selectedOrder() {
      clearInterval(this.orderStatusInterval);
    }
  }
}
</script>

<style lang="scss" scoped>
.thread-container {
  overflow-y: auto;
  height: calc(100vh - 170px - (var(--free-trial-height) / 2.5));
}
</style>
